import { render, staticRenderFns } from "./WaterSubmissionForm.vue?vue&type=template&id=7f66e518"
import script from "./WaterSubmissionForm.vue?vue&type=script&lang=js"
export * from "./WaterSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports